export default function Logo({ size = 40 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label="ZAKI Logistics LLC logo"
      data-testid="zaki-logo"
    >
      <rect width="64" height="64" rx="14" fill="#111827" />
      <path
        d="M17 17h30L23 47h28"
        fill="none"
        stroke="#2563EB"
        strokeWidth="9"
        strokeLinecap="square"
      />
      <path
        d="M41 24.5 29 39.5"
        fill="none"
        stroke="#06B6D4"
        strokeWidth="3"
        strokeDasharray="5 6"
        strokeLinecap="round"
      />
    </svg>
  );
}
